import axios from 'axios'
export default {
    namespaced: true,
    state: {
        name: 'CatalogVehicleEstimate',
		endpoint: '/catalog/vehicle/estimate',
		params: {},
        item: {},
        items: [],
    },
    actions: {
		estimate (context, params) {
			return axios.post(context.getters.endpoint, params).then(response => {
				//console.log('search','response.data', response.data)
				context.commit('item', response.data)
			}, error => {
				console.log(error)
			})
		},

		/* find (context, id) {
			return axios.get(`${context.getters.endpoint}/${id}`).then(response => {
				//console.log('find','response.data', response.data)
				context.commit('item', response.data)
			}, error => {
				console.log(error)
			})
		},

		search (context, params) {
			return axios.get(context.getters.endpoint, { params: params }).then(response => {
				//console.log('search','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		}, */
    }
}